/* tslint:disable */
/* eslint-disable */
/**
 * Proposed Symmons Customer Internal API
 * ## REST API This application will follow the RESTful API pattern. Each object below is a resource. Resources can be accessed via a CRUD pattern, using HTTP verbs to request actions on specific resources. Resource endpoints are named with plural and singular names to indicate the kind of query. So `GET /companies` will fetch a list of companies, whereas `GET /company/1` will fetch a single company.  ## Resources __User__ is an authenticatable user object. User authentication will be required for access to all data. Users must have at least one role: - __user__: Can access all orders within their company. Can search for all products, and see pricing specific to their company and locations - __location manager__ : Inherits user. Can onboard new users within a location. Can create and report on locations - __company manager__: Inherits user. Can onboard new users within a location. May be able to manage locations - __administrator__: Symmons Administrators. Can create companies, manage locations, view diagnostics and reports, and onboard users __Order__ is the object that contains a single order, identified by an order id. Each order will contain an array of line items. __OrderLine__ is a single line item, generally a single product. The line has a unique identifier, which is a hashed composite of the order id and the line increment number. Each order contains a short form of the product for rendering a product title, price, shipping information, and image. __Company__ is an organizational structure for users and order. Companies have many orders and many users, and any user in a company, can have access any order. Orders are accessed via a bill_to_id. Each company has one bill_to_id and we control access via that bill_to_id. __Location__ Each company also can have multiple ship_to_ids, defining multiple locations. Each company has multiple locations and users can be associated with multiple locations. This way a user can filter to see only orders associated with their location. __Product__ is a salsify product object. Order lines contain products, and products are shipped to algolia for display on the frontend product search. Products are necessary for the price lookup. __Price__ is an object that describes the special pricing for a particular product and user.  ## Authentication We will use a JWT authentication schema, powered by Laravel Passport. Users are authenticated by submitting credentials to the /oauth/token endpoint. Any client seeing JWT authentication will need to supply a client id and  ## Additional considerations ### IDs Companies and Locations have an internal middleware id and then the admin editable bill_to and ship_to ids that connect them back to the parent records in the symmons database. ### Pagination List endpoints are paginated at 30 per page. The ?page={int} query string will allow paging through the list results.  Page is indexed from 0, so 1 is the second page of results. If needed, ?perPage={int} can be used to page the results ### Responses At present we have defined the following possible responses codes for each request. - 200 indicates a successful query and returns data. - 204 indicates the request was successful and no response will be returned. - 401 indicates a bad authentication token. - 403 indicates the user cannot access a particular resource. - 404 indicates the record cannot be found. - 422 indicates the request JSON cannot be parsed. - 500 indicates a critical system error. These errors will be logged in sentry 
 *
 * The version of the OpenAPI document: v0.0.1
 * Contact: brad@convertiv.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from "./configuration";
import { RequiredError,　RequestArgs } from "./base";
import { AxiosInstance } from 'axios';

/**
 *
 * @export
 */
export const DUMMY_BASE_URL = 'https://example.com'

/**
 *
 * @throws {RequiredError}
 * @export
 */
export const assertParamExists = function (functionName: string, paramName: string, paramValue: unknown) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
    }
}

/**
 *
 * @export
 */
export const setApiKeyToObject = async function (object: any, keyParamName: string, configuration?: Configuration) {
    if (configuration && configuration.apiKey) {
        const localVarApiKeyValue = typeof configuration.apiKey === 'function'
            ? await configuration.apiKey(keyParamName)
            : await configuration.apiKey;
        object[keyParamName] = localVarApiKeyValue;
    }
}

/**
 *
 * @export
 */
export const setBasicAuthToObject = function (object: any, configuration?: Configuration) {
    if (configuration && (configuration.username || configuration.password)) {
        object["auth"] = { username: configuration.username, password: configuration.password };
    }
}

/**
 *
 * @export
 */
export const setBearerAuthToObject = async function (object: any, configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const accessToken = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + accessToken;
    }
}

/**
 *
 * @export
 */
export const setOAuthToObject = async function (object: any, name: string, scopes: string[], configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken(name, scopes)
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + localVarAccessTokenValue;
    }
}

/**
 *
 * @export
 */
export const setSearchParams = function (url: URL, ...objects: any[]) {
    const searchParams = new URLSearchParams(url.search);
    for (const object of objects) {
        for (const key in object) {
            if (Array.isArray(object[key])) {
                searchParams.delete(key);
                for (const item of object[key]) {
                    searchParams.append(key, item);
                }
            } else {
                searchParams.set(key, object[key]);
            }
        }
    }
    url.search = searchParams.toString();
}

/**
 *
 * @export
 */
export const serializeDataIfNeeded = function (value: any, requestOptions: any, configuration?: Configuration) {
    const nonString = typeof value !== 'string';
    const needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
}

/**
 *
 * @export
 */
export const toPathString = function (url: URL) {
    return url.pathname + url.search + url.hash
}

/**
 *
 * @export
 */
export const createRequestFunction = function (axiosArgs: RequestArgs, globalAxios: AxiosInstance, BASE_PATH: string, configuration?: Configuration) {
    const requestFn = (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...axiosArgs.options, url: (configuration?.basePath || basePath) + axiosArgs.url};
        return axios.request(axiosRequestArgs);
    };

    requestFn.getQueryKey = (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...axiosArgs.options, url: (configuration?.basePath || basePath) + axiosArgs.url};
        const url = new URL(axios.getUri(axiosRequestArgs));

        return [
          `${url.origin}${url.pathname}`,
          url.searchParams.toString(),
          JSON.stringify(axiosArgs.options),
        ];
    };

    return requestFn;
}